"use strict";
exports.__esModule = true;
require('./radio.css');
exports.default = {
  "modifiers": {
    "standalone": "pf-m-standalone",
    "disabled": "pf-m-disabled"
  },
  "radio": "pf-v5-c-radio",
  "radioBody": "pf-v5-c-radio__body",
  "radioDescription": "pf-v5-c-radio__description",
  "radioInput": "pf-v5-c-radio__input",
  "radioLabel": "pf-v5-c-radio__label"
};